/**
 * Desfecho que a interface consegue oferecer para cada conflito de sessão.
 *
 * A regra recebe somente o código publicado pelo backend. Ela não conhece
 * HTTP, Vuex ou tradução em runtime; o chamador decide como materializar a
 * chave em uma mensagem e se precisa limpar a submissão em curso.
 */
export type TipoDeDesfechoDeConflito =
  | 'conversa_ocupada'
  | 'revisao_desatualizada'
  | 'sessao_travada'
  | 'submissao_conflitante'
  | 'generico'

export interface DesfechoDeConflito {
  tipo: TipoDeDesfechoDeConflito
  chaveDeTexto: string
  retentavel: boolean
  recuperavel: boolean
  descartarSubmissao: boolean
}

const DESFECHO_CONVERSA_OCUPADA: DesfechoDeConflito = {
  tipo: 'conversa_ocupada',
  chaveDeTexto: 'assistentePontotel.erro.sessaoOcupada',
  retentavel: true,
  recuperavel: false,
  descartarSubmissao: false
}

const DESFECHO_REVISAO_DESATUALIZADA: DesfechoDeConflito = {
  tipo: 'revisao_desatualizada',
  chaveDeTexto: 'assistentePontotel.erro.revisaoDesatualizada',
  retentavel: true,
  recuperavel: false,
  descartarSubmissao: false
}

const DESFECHO_SESSAO_TRAVADA: DesfechoDeConflito = {
  tipo: 'sessao_travada',
  chaveDeTexto: 'assistentePontotel.erro.sessaoTravada',
  retentavel: false,
  recuperavel: true,
  descartarSubmissao: true
}

const DESFECHO_SUBMISSAO_CONFLITANTE: DesfechoDeConflito = {
  tipo: 'submissao_conflitante',
  chaveDeTexto: 'assistentePontotel.erro.conflitoSubmissao',
  retentavel: false,
  recuperavel: false,
  descartarSubmissao: true
}

const DESFECHO_GENERICO: DesfechoDeConflito = {
  tipo: 'generico',
  chaveDeTexto: 'assistentePontotel.erro.mensagem',
  retentavel: true,
  recuperavel: false,
  descartarSubmissao: false
}

/**
 * Traduz os quatro conflitos publicados e degrada códigos novos para o
 * caminho genérico. Nenhuma entrada ou saída é mutada, e o objeto devolvido é
 * sempre uma cópia para que um consumidor não altere a tabela compartilhada.
 */
export function desfechoDoConflito (codigo: string): DesfechoDeConflito {
  const desfecho = codigo === 'session_busy'
    ? DESFECHO_CONVERSA_OCUPADA
    : codigo === 'session_revision_conflict'
      ? DESFECHO_REVISAO_DESATUALIZADA
      : codigo === 'session_closed'
        ? DESFECHO_SESSAO_TRAVADA
        : codigo === 'interaction_submission_conflict'
          ? DESFECHO_SUBMISSAO_CONFLITANTE
          : DESFECHO_GENERICO

  return { ...desfecho }
}
